import createActions from 'utils/redux/createActions'

export default createActions([
	'SWITCH_OMNI'
])



// WEBPACK FOOTER //
// ./src/actions/mobile.js